exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-layout-sider-children {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100%;\n}\n.ant-tabs-card {\n  -ms-flex: 1 1;\n      flex: 1 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.ant-tabs-tabpane-active {\n  height: 100%;\n}\n.ant-tabs-content-no-animated {\n  -ms-flex: 1 1;\n      flex: 1 1;\n}\n.mobileMenu {\n  border: 1px #ececec solid;\n  padding: 5px;\n}\n.mobileMenu:hover {\n  border: 1px #157efb solid;\n}\n.mobileMenuHover {\n  border: 1px #157efb solid;\n  padding: 5px;\n}\n.mobileMenuIcon {\n  text-align: center;\n  padding-top: 10px;\n  color: #157efb;\n}\n.mobileMenuIcon .anticon {\n  font-size: 24px;\n}\n.mobileMenuName {\n  text-align: center;\n  font-size: 14px;\n  padding-bottom: 5px;\n  color: #333333;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/components/SiderMenu/style.css
// module id = 1601
// module chunks = 0